<template>
  <div class="mobile-menu">
    <div class="container">
      <div class="mobile-menu__top">
        <div class="mobile-menu__logo"><img @click="resetToHome" src="/logo@2x.png" alt="Cerner" class="logo"></div>
        <div class="mobile-menu__ham-nav" v-bind:class="{ 'open': menuOpen }" @click="toggleMenu">
          <span class="ham-nav__top ham-nav__bar"></span>
          <span class="ham-nav__middle ham-nav__bar"></span>
          <span class="ham-nav__bottom ham-nav__bar"></span>
        </div>
      </div>
      <div class="mobile-menu__drop-down" v-bind:class="{ 'open': menuOpen }">
        <a href="#"><svg class="icon icon-Info"><use xlink:href="#icon-Info"></use></svg> Help + Information</a>
        <a v-if="$route.path == '/portal'" href="/share"><svg class="icon icon-Share"><use xlink:href="#icon-Share"></use></svg> Share Portal</a>
        <a v-if="$route.path == '/share'" href="/portal"><svg class="icon icon-Grid"><use xlink:href="#icon-Grid"></use></svg> Dashboard</a>
        <a v-if="$route.path != '/portal' && $route.path != '/share'" href="/custom-dashboard" @click="reset"><svg class="icon icon-Refresh"><use xlink:href="#icon-Refresh"></use></svg> Start Over</a>
        <a href="/" @click="reset"><svg class="icon icon-Exit"><use xlink:href="#icon-Exit"></use></svg> Exit Portal</a>
      </div>
    </div>
  </div>
</template>

<script>
  import router from '../router.js';
  
  export default {
    name : "MobileMenu",
    data : function() {
      return {
        menuOpen: false
      }
    },
    methods: {
      toggleMenu() {
        this.menuOpen = !this.menuOpen;

        if ( this.menuOpen ) {
          $( 'body' ).addClass( 'locked' );
        } else {
          $( 'body' ).removeClass( 'locked' );
        }
      },
      resetToHome() {
          sessionStorage.clear();
          router.push('/');
      },
      reset(event) {
          sessionStorage.clear();
      },
    }
  }
</script>

<style>
  body.locked {
    background-color: #FEFEFE;
  }
</style>

<style scoped>
  .mobile-menu {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 50px;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    z-index: 3;
    background-color:#FEFEFE;
    padding-bottom: 2em;
  }

  .mobile-menu .container {
    width: 92.6% !important;
    padding-left: 1em !important;
    padding-right: 1em !important;
    margin-top: 2em;
  }

  .mobile-menu__top {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    z-index: 2;
  }

  .mobile-menu__top .logo {
    max-height: 50px;
    cursor: pointer;
  }

  @media screen and (max-width: 480px) {
    .mobile-menu__top .logo {
      max-width: 80%;
    }
  }

  .mobile-menu__ham-nav {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    width: 50px;
    height: 50px;
    cursor: pointer;
    margin-right: -10px;
  }

  .ham-nav__bar {
    background-color: #666;
    width: 30px;
    height: 4px;
    transition: all 0.3s ease-in-out;
  }

  .ham-nav__middle {
    margin: 5px 0;
  }

  .mobile-menu__ham-nav.open .ham-nav__middle {
    display: none;
    transition: all 0.3s 0.3s ease-in-out;
  }

  .mobile-menu__ham-nav.open .ham-nav__top {
    transform: translateX(1px) translateY(3px) rotate(45deg);
  }

  .mobile-menu__ham-nav.open .ham-nav__bottom {
    transform: translateY(-1px) rotate(-45deg);
  }

  .mobile-menu__drop-down {
    position: absolute;
    top: -100vh;
    left: 0;
    width: 100%;
    height: calc( 100vh - 50px );
    display: flex;
    align-items: center;
    justify-content: flex-start;
    flex-direction: column;
    width: 100%;
    z-index: -1;
    background-color: #FEFEFE;
    padding-top: 2em;
    transition: all 0.3s ease-in-out;
    opacity: 0;
  }

  .mobile-menu__drop-down.open {
    top: 100%;
    opacity: 1;
  }

  .mobile-menu__drop-down::before {
    content: '';
    position: absolute;
    top: 0;
    left: -50%;
    width: 200%;
    height: 100%;
    background-color: #FEFEFE;
    z-index: -1;
  }

  .mobile-menu__drop-down a {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    margin-top: 1.5em;
    color: #666;
    font-size: 1.5em;
    text-decoration: none;
  }

  .mobile-menu__drop-down a:hover {
    color: #2DA1D6;
  }

  .mobile-menu__drop-down a .icon {
    margin-bottom: 0.5em;
  }
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/MobileMenu.vue